module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/safe-mobile-phone.dd889439.png";